<template>
  <div class="container p-2" :style="`width: ${box_width}px; background-color: #f9f9f9;`">
    <div class="row row-cold-2">
      <div class="col-12 col-md-5 order-4 order-md-2">
        <div class="input-group mb-2 mt-2">
          <button
            style="width: 35px"
            class="btn btn-outline-success text-center"
            id="step-up"
            @click="stepUpTransit"
            type="button"
          >
            +
          </button>
          <select
            class="form-select text-center"
            id="inputGroupSelect01"
            v-model="intervalTransit"
            style=""
            @select="setIntervalTransit"
          >
            <option style="direction: rtl" value="1-minute" selected>۱ دقیقه</option>
            <option style="direction: rtl" value="10-minute">۱۰ دقیقه</option>
            <option style="direction: rtl" value="1-hour">۱ ساعت</option>
            <option style="direction: rtl" value="1-day">۱ روز</option>
            <option style="direction: rtl" value="1-week">۱ هفته</option>
            <option style="direction: rtl" value="1-month">۱ ماه</option>
            <option style="direction: rtl" value="1-year">۱ سال</option>
          </select>
          <button
            class="btn btn-outline-success"
            id="step-down"
            @click="stepDownTransit"
            type="button"
            style="width: 35px"
          >
            -
          </button>
        </div>
      </div>

      <div class="col-sm-12 col-md-7 m-0 order-2 order-md-2">
        <div class="input-group mb-2 mt-2 mr-auto mx-auto" style="direction: ltr">
          <input
            @change="onChange"
            type="number"
            maxlength="4"
            v-model="transit_year"
            placeholder="سال"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
          <input
            @change="onChange"
            type="number"
            maxlength="2"
            min="1"
            max="12"
            v-model="transit_month"
            placeholder="ماه"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
          <input
            @change="onChange"
            type="number"
            min="1"
            max="31"
            maxlength="2"
            v-model="transit_day"
            placeholder="روز"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
        </div>
      </div>

      <div class="col-12 col-md-5 order-3">
        <div class="d-flex mb-2 mt-2 text-center">
          <button
            type="button"
            class="btn btn-sm btn-outline-success ms-auto me-1"
            style=""
            @click="submitTransit"
          >
            محاسبه
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-success ms-1 me-auto"
            style="height: 35px"
            @click="setNow"
          >
            اکنون
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-md-7 m-0 order-1 order-md-4">
        <div class="input-group mb-2 mt-2 mr-auto mx-auto order-1" style="direction: ltr">
          <input
            type="number"
            maxlength="2"
            min="0"
            max="23"
            v-model="transit_hour"
            placeholder="ساعت"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
          <input
            type="number"
            maxlength="2"
            min="0"
            max="59"
            v-model="transit_min"
            placeholder="دقیقه"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
          <input
            type="number"
            maxlength="2"
            min="0"
            max="59"
            v-model="transit_sec"
            placeholder="ثانیه"
            class="form-control text-center"
            aria-describedby="button-addon1"
          />
        </div>
      </div>
    </div>

    <div
      class="col-11 order-3 mb-3 order-3 mr-auto mx-auto p-2 mt-2"
      v-if="error"
      style="
        direction: rtl;
        font-size: 14px;
        color: red;
        text-align: center;
        text-shadow: rgb(255, 255, 255) 1px 1px;
        border: 1px solid red;
        border-radius: 7px;
      "
    >
      تاریخ نامعتبر است
    </div>
  </div>
</template>

<script>
import moment from "jalali-moment";

export default {
  name: "TransitForm",
  props: [
    "t_year",
    "t_month",
    "t_day",
    "t_hour",
    "t_min",
    "t_sec",
    "timezone",
    "t_date_type",
    "box_width",
  ],
  data() {
    return {
      error: false,
      transit_year: this.t_year,
      transit_month: this.t_month,
      transit_day: this.t_day,
      transit_hour: this.t_hour,
      transit_min: this.t_min,
      transit_sec: this.t_sec,
      date_locale: this.t_date_type == "jalali" ? "fa" : "en",
      date_format: this.t_date_type == "jalali" ? "jYYYY-jMM-jDD" : "YYYY-MM-DD",
      intervalTransit: "1-minute",
    };
  },
  watch: {
    t_year: function (value) {
      if (this.transit_month && this.transit_day && this.t_date_type && value >= 0) {
        if (
          moment
            .from(
              `${value}-${this.transit_month}-${this.transit_day}`,
              this.date_locale,
              this.date_format
            )
            .isValid()
        ) {
          // console.log(value)
          this.transit_year = value;
          this.error = false;
        } else {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    },
    t_month: function (value) {
      // console.log(this.transit_month)
      // console.log(value)
      if (
        this.transit_year &&
        this.transit_day &&
        this.t_date_type &&
        value <= 12 &&
        value >= 0
      ) {
        if (
          moment
            .from(
              `${this.transit_year}-${value}-${this.transit_day}`,
              this.date_locale,
              this.date_format
            )
            .isValid()
        ) {
          this.transit_month = value;
          this.error = false;
        } else {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    },
    t_day: function (value) {
      if (
        this.transit_year &&
        this.transit_month &&
        this.t_date_type &&
        value >= 0 &&
        value <= 31
      ) {
        if (
          moment
            .from(
              `${this.transit_year}-${this.transit_month}-${value}`,
              this.date_locale,
              this.date_format
            )
            .isValid()
        ) {
          this.transit_day = value;
          this.error = false;
        } else {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    },
    t_hour: function (value) {
      // console.log(value);
      if (this.transit_min && this.transit_sec) {
        if (parseInt(value) >= 0 && parseInt(value) < 24) {
          this.error = false;
          this.transit_hour = value;
        } else {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    },
    t_min: function (value) {
      if (this.transit_hour && this.transit_sec) {
        if (parseInt(value) >= 0 && parseInt(value) < 60) {
          this.error = false;
          this.transit_min = value;
        } else {
          this.error = true;
        }
      } else {
        this.error = true;
      }
    },
    t_sec: function (value) {
      if (this.transit_hour && this.transit_min) {
        if (parseInt(value) >= 0 && parseInt(value) < 60) {
          this.error = false;
          this.transit_sec = value;
        } else {
          this.error = true;
        }
      } else {
        this.error = false;
      }
    },
  },
  methods: {
    stepDownTransit() {
      const amount = this.intervalTransit.split("-")[0];
      const unit = this.intervalTransit.split("-")[1];
      const date_locale = this.t_date_type == "jalali" ? "fa" : "en";
      const date_format =
        this.t_date_type == "jalali" ? "jYYYY-jMM-jDD HH:mm:ss" : "YYYY-MM-DD HH:mm:ss";

      const target = moment
        .from(
          `${this.transit_year}-${this.transit_month}-${this.transit_day} ${this.transit_hour}:${this.transit_min}:${this.transit_sec}`,
          date_locale,
          date_format
        )
        .subtract(parseInt(amount), unit);

      this.transit_hour = target.format("HH");
      this.transit_min = target.format("mm");
      this.transit_sec = target.format("ss");

      if (this.t_date_type == "jalali") {
        this.transit_year = target.format("jYYYY");
        this.transit_month = target.format("jMM");
        this.transit_day = target.format("jDD");
      } else {
        this.transit_year = target.format("YYYY");
        this.transit_month = target.format("MM");
        this.transit_day = target.format("DD");
      }

      this.$emit(
        "submitTransitData",
        true,
        this.transit_year,
        this.transit_month,
        this.transit_day,
        this.transit_hour,
        this.transit_min,
        this.transit_sec
      );
    },
    stepUpTransit() {
      const amount = this.intervalTransit.split("-")[0];
      const unit = this.intervalTransit.split("-")[1];
      const date_locale = this.t_date_type == "jalali" ? "fa" : "en";
      const date_format =
        this.t_date_type == "jalali" ? "jYYYY-jMM-jDD HH:mm:ss" : "YYYY-MM-DD HH:mm:ss";
      const t_date_format =
        this.t_date_type == "jalali" ? "YYYY-MM-DD HH:mm:ss" : "jYYYY-jMM-jDD HH:mm:ss";

      const target = moment
        .from(
          `${this.transit_year}-${this.transit_month}-${this.transit_day} ${this.transit_hour}:${this.transit_min}:${this.transit_sec}`,
          date_locale,
          date_format
        )
        .add(parseInt(amount), unit);

      if (this.t_date_type == "jalali") {
        this.transit_year = target.format("jYYYY");
        this.transit_month = target.format("jMM");
        this.transit_day = target.format("jDD");
        this.transit_hour = target.format("HH");
        this.transit_min = target.format("mm");
        this.transit_sec = target.format("ss");
      } else {
        this.transit_year = target.format("YYYY");
        this.transit_month = target.format("MM");
        this.transit_day = target.format("DD");
        this.transit_hour = target.format("HH");
        this.transit_min = target.format("mm");
        this.transit_sec = target.format("ss");
      }

      this.$emit(
        "submitTransitData",
        true,
        this.transit_year,
        this.transit_month,
        this.transit_day,
        this.transit_hour,
        this.transit_min,
        this.transit_sec
      );
    },
    setIntervalTransit(value) {
      this.intervalTransit = value.target.value;
    },
    getRange(start, end, step) {
      return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), (x) =>
        String(start + x * step).toString()
      );
    },
    onChange() {
      this.$emit(
        "updateTransitData",
        this.transit_year,
        this.transit_month,
        this.transit_day,
        this.transit_hour,
        this.transit_min,
        this.transit_sec
      );
    },
    setTransit() {
      const date_locale = this.t_date_type == "jalali" ? "fa" : "en";
      const date_format = this.t_date_type == "jalali" ? "jYYYY-jMM-jDD" : "YYYY-MM-DD";

      if (
        moment
          .from(
            `${this.transit_year}-${this.transit_month}-${this.transit_day}`,
            date_locale,
            date_format
          )
          .isValid() &&
        this.error == false
      ) {
        this.$emit(
          "submitTransitData",
          true,
          this.transit_year,
          this.transit_month,
          this.transit_day,
          this.transit_hour,
          this.transit_min,
          this.transit_sec
        );
      } else {
        this.error = true;
      }
    },
    setNow() {
      const now = moment().utcOffset(this.timezone);

      if (this.t_date_type == "jalali") {
        this.transit_year = now.format("jYYYY");
        this.transit_month = now.format("jMM");
        this.transit_day = now.format("jDD");
        this.transit_hour = now.format("HH");
        this.transit_min = now.format("mm");
        this.transit_sec = now.format("ss");
      } else {
        this.transit_year = now.format("YYYY");
        this.transit_month = now.format("MM");
        this.transit_day = now.format("DD");
        this.transit_hour = now.format("HH");
        this.transit_min = now.format("mm");
        this.transit_sec = now.format("ss");
      }

      if (
        moment
          .from(
            `${this.transit_year}-${this.transit_month}-${this.transit_day}`,
            this.date_locale,
            this.date_format
          )
          .isValid() &&
        this.error == false
      ) {
        this.$emit(
          "submitTransitData",
          true,
          this.transit_year,
          this.transit_month,
          this.transit_day,
          this.transit_hour,
          this.transit_min,
          this.transit_sec
        );
      } else {
        this.error = true;
      }
    },

    submitTransit() {
      const date_locale = this.t_date_type == "jalali" ? "fa" : "en";
      const date_format = this.t_date_type == "jalali" ? "jYYYY-jMM-jDD" : "YYYY-MM-DD";

      // Add leading zeros if necesscary
      const formattedYear = this.transit_year.padStart(2, "0");
      const formattedMonth = this.transit_month.padStart(2, "0");
      const formattedDay = this.transit_day.padStart(2, "0");
      const formattedHour = this.transit_hour.padStart(2, "0");
      const formattedMinute = this.transit_min.padStart(2, "0");
      const formattedSecond = this.transit_sec.padStart(2, "0");

      if (
        moment
          .from(
            `${formattedYear}-${formattedMonth}-${formattedDay}`,
            date_locale,
            date_format
          )
          .isValid() &&
        this.error == false
      ) {
        this.$emit(
          "submitTransitData",
          true,
          formattedYear,
          formattedMonth,
          formattedDay,
          formattedHour,
          formattedMinute,
          formattedSecond
        );
      } else {
        this.error = true;
      }
    },
  },
};
</script>
